<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ปฏิทินวันหยุด</span>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="uiCtrl && !uiCtrl.isEnable('btn:::holiday:create')"
        color="primary"
        @click="handleAddHolidayForm"
      >
        <v-icon small left>mdi-plus</v-icon>เพิ่มวันหยุด
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterHolidayType"
            :items="holidayTypes"
            item-text="title_th"
            item-value="holiday_type_uuid"
            label="ประเภทวันหยุด"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="holiday"
      :custom-filter="customFilter"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.holiday_date="{ item }">
        {{ item.holiday_date | dateFormat }}
      </template>
      <template v-slot:item.holiday_type="{ item }">
        {{ item.holiday_type.title_th }}
      </template>
    </v-data-table>
    <HolidayForm
      :formShow="holidayFormShow"
      :formAction="holidayFormAction"
      :holidayItem="holidayItem"
      :holidayItemInit="holidayItemInit"
      @isHolidayDataChange="handleHolidayFormDataChange"
      @formActionCompleted="handleHolidayFormActionCompleted"
      @onReset="handleHolidayFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="holidayFormShow && holidayFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import HolidayForm from '@/views/holiday/HolidayForm.vue'

export default {
  components: {
    HolidayForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['holiday_date'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      filterHolidayType: '',
      holidayFormShow: false,
      holidayFormAction: '',
      holidayItem: {},
      holidayItemInit: {},
      isHolidayDataChange: false,
      timeout: null,
    }
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format('DD/MM/YYYY') || ''
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headers() {
      return [
        { text: 'วันที่', align: 'start', value: 'holiday_date' },
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        { text: 'คำอธิบาย (อังกฤษ)', align: 'start', value: 'title_en' },
        {
          text: 'ประเภทวันหยุด',
          align: 'start',
          value: 'holiday_type',
          filter: (value) => {
            if (!this.filterHolidayType) {
              return true
            }
            return value.holiday_type_uuid === this.filterHolidayType
          },
        },
      ]
    },
    holiday() {
      return this.$store.state.holiday.holiday
    },
    holidayTypes() {
      return this.$store.state.holiday.holidayTypes
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ปฏิทินวันหยุด',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    const payload = {
      company_uuid,
    }

    this.loading = true

    Promise.all([this.fetchHoliday(payload), this.fetchHolidayTypes()])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchHoliday: 'holiday/fetchHoliday',
      fetchHolidayTypes: 'holiday/fetchHolidayTypes',
    }),
    customFilter(value, search, item) {
      return (
        moment(item.holiday_date)
          .format('DD/MM/YYYY')
          .includes(search.toLowerCase()) ||
        item.title_th?.toLowerCase().includes(search.toLowerCase()) ||
        item.title_en?.toLowerCase().includes(search.toLowerCase()) ||
        item.holiday_type.title_th?.toLowerCase().includes(search.toLowerCase())
      )
    },
    classRowSelected(row) {
      if (this.holidayItem.holiday_uuid === row.holiday_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::holiday:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.holidayItem.holiday_uuid === row.holiday_uuid) {
        this.holidayFormShow = false
        this.holidayFormAction = ''
        this.holidayItem = {}
        this.holidayItemInit = {}
      } else {
        this.holidayFormShow = true
        this.holidayFormAction = 'edit'
        this.holidayItem = {
          ...row,
          holiday_type_uuid: row.holiday_type?.holiday_type_uuid,
        }
        this.holidayItemInit = {
          ...row,
          holiday_type_uuid: row.holiday_type?.holiday_type_uuid,
        }
      }
    },
    handleRowSelected(row) {
      if (this.isHolidayDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddHolidayForm() {
      this.holidayFormShow = true
      this.holidayFormAction = 'add'
      this.holidayItem = {}
      this.holidayItemInit = {}
    },
    handleHolidayFormDataChange(value) {
      this.isHolidayDataChange = value
    },
    handleHolidayFormReset(formAction) {
      if (formAction === 'edit') {
        this.holidayItem = { ...this.holidayItemInit }
      }
    },
    handleHolidayFormActionCompleted(formAction) {
      this.holidayItem = {}
      this.holidayItemInit = {}
      this.holidayFormShow = false
      this.holidayFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.holidayFormShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isHolidayDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
